import React from 'react';
import ContainerBase from '../atomic/Container';

const Container = (props) => <ContainerBase {...props} />;

export default Container;
